import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, catchError, tap, of, take } from "rxjs";
import { Store } from "@ngrx/store";
import { LoadMedias, MediaModel, MediaState } from "../store";
import { MediaService } from "./media.lib.service";
import { NotificationService } from "libs/tm-common/src/lib/services";

@Injectable({
	providedIn: 'root'
})

export class MediaResolver {
	private store = inject<Store<MediaState>>(Store);
	private notificationService = inject(NotificationService);
	private mediaService = inject(MediaService);


	resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<MediaModel[]> {
		return this.mediaService.getMediaFiles(route.params.id, true).pipe(
			take(1),
			tap((mediaFiles: MediaModel[]) =>
				this.store.dispatch(new LoadMedias({ medias: mediaFiles }))
			),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolveMediaFilesError", "", 5000);
				return of([]); //Open route, even if media files could not be loaded
			})
		);
	}
}
